import React from 'react'
import CaseStudyHeader from '../../components/Header/CSHeader/CaseStudyHeader.jsx'

import colors from './assets/colors.webp'
import designtokens from './assets/designtokens.webp'
import grid from './assets/grid.webp'
import n1cover from './assets/n1cover.webp'

import principles2 from './assets/principles2.webp'
import typography from './assets/typography.webp'


function DS() {


    return (

        <section>

            <CaseStudyHeader Pagetitle="Building N1 Design system" />

            <img
                className='cover-img'
                src={n1cover}
                alt=""
                loading="lazy"
            />


            <div className='cs-content'>


                <div className="top-l"></div>


                <h2>Building N1 Design system from scratch.</h2>


            </div>


            <div className='cs-content'>

                <p className="md">
                    N1 is a design system built for creating consistent ERP dashboards at Nathan Digital. It was designed to be scalable, cohesive, and efficient. As the company grew and took on more digital projects, N1 became essential for maintaining consistency while speeding up both design and development processes.
                </p>


            </div>

            <div className='cs-content'>

                <h4>The need for building the design system</h4>


                <p>
                    When I joined the company, the software had been designed without a design system in place. As I began working on the accounting system, it quickly became clear that the number of screens was substantial, and without a design system, the product would struggle to scale in a cohesive and efficient way. <br /> <br />

                    I had already started to noticed numerous inconsistencies across the user interface, which not only affected usability but also weakened the overall brand identity. Recognizing the long-term impact of this, I took the initiative to advocate for the implementation of a design system. I presented to management how a unified system could reduce both design and development time, improve consistency, and ultimately create a better user experience.
                </p>

            </div>

            <div className='cs-content'>

                <h4>Achievements and impact on design.</h4>

                <p>
                    After we introduced the design system, we saw a 23% decrease in design time. This was based on comparing how long it took the team to design a set number of screens before and after the system was in place. It clearly showed that the design system helped us work faster and more efficiently.
                    <br /><br />
                    The design system also made a big difference in the consistency of our ERP products. With a shared visual style and clear design rules, every screen and component looked and felt part of the same product, which helped strengthen our brand.
                    <br /><br />
                    This improvement in both speed and consistency made our work easier to scale and maintain. It also helped the design and development teams work together more smoothly, leading to faster and more reliable project delivery.
                </p>

            </div>

            <div className="cs-content">
                <h6>NELSON NORMAN GROUP</h6>
                <p className="lg">In a study by Nielsen Norman Group, organisations reported up to a 75% increase in development efficiency with the use of design systems.</p>
            </div>


            <div className='cs-content'>

                <h4>How to build a design system the right way?</h4>

                <p>After reading a lot over the internet i realized the atomic concept is the right way to build the design system the website ‘atomicdesign’ by brandfrost became a big help.</p>

            </div>

            <div className='cs-content'>

                <h4>Setting the principles</h4>

                <p>
                    Every design system is build upon principles, they define the why and purpose of building design system and the priorities the team have behind the deisgn system. These principles guide decision-making and explain how the design system’s creators want team members to use the system. After several hours, numerous rounds of coffee, and multiple meetings, we refined these principles to encapsulate the essence of our approach & brand.
                    <br /><br />
                    we wanted our design system to be
                </p>

                <img src={principles2} alt="" />

            </div>


            <div className='cs-content'>

                <h4>Foundation</h4>

                <p>Since most of our software products were dashboard-based, setting up the foundational design system was relatively straightforward. I implemented a 12-column grid and a 4pt spacing system to ensure precise control, alignment, and visual consistency across layouts.
                    <br /><br />
                    When selecting a typeface, we wanted something that felt both playful and professional—complementing the rounded-corner aesthetic of the interface we also wanted clarity at both small and large sizes. After evaluating several options, we  agreed on Figtree, which struck the right balance in tone and readability.
                    <br /> <br />
                    For the color palette, blue was chosen as the primary color to convey a more corporate and trustworthy feel, aligning with the business-oriented nature of our products.

                </p>

                <img src={colors} alt="" />
                <img src={grid} alt="" />
                <img src={typography} alt="" />

            </div>

            <div className='cs-content'>

                <h4>Design token</h4>

                <p>I wanted to keep the design token simple because it can get quite confusing with larger tier architecture. i went with a 2 tired token architecture which was simple and had enough complexity for the design system.


                </p>

                <img src={designtokens} alt="" />

            </div>

            <div className='cs-content'>

                <h4>Achievements and impact on design.</h4>

                <p>
                    After we introduced the design system, we saw a 23% decrease in design time. This was based on comparing how long it took the team to design a set number of screens before and after the system was in place. It clearly showed that the design system helped us work faster and more efficiently.

                    <br /><br />
                    The design system also made a big difference in the **consistency** of our ERP products. With a shared visual style and clear design rules, every screen and component looked and felt part of the same product, which helped strengthen our brand.
                    <br /><br />

                    This improvement in both speed and consistency made our work easier to scale and maintain. It also helped the design and development teams work together more smoothly, leading to faster and more reliable project delivery.

                </p>



            </div>






            <div className='cs-content'>

            </div>


            {/* 

            <div className='toc-container'>

                <div className="top-l"></div>
                <a href="/"><p>As a team member </p></a>
                <a href="/"><p>Go to Link 1</p></a>
                <a href="/"><p>Go to Link 1</p></a>
                <a href="/"><p>Go to Link 1</p></a>
                <a href="/"><p>Go to Link 1</p></a>
                <a href="/"><p>Go to Link 1</p></a>
            </div> */}


        </section>


    )
}

export default DS